import React, { useState, useEffect } from 'react';

const NOTES_KEY = 'dominionbible_notes';
const BOOKMARKS_KEY = 'dominionbible_bookmarks';

function getStored(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
}

function setStored(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

const UserContent = ({ currentBook, currentChapter, selectedVerse }) => {
  // Notes
  const [notes, setNotes] = useState(() => getStored(NOTES_KEY, []));
  const [noteText, setNoteText] = useState('');
  // Bookmarks
  const [bookmarks, setBookmarks] = useState(() => getStored(BOOKMARKS_KEY, []));

  // Save to localStorage on change
  useEffect(() => { setStored(NOTES_KEY, notes); }, [notes]);
  useEffect(() => { setStored(BOOKMARKS_KEY, bookmarks); }, [bookmarks]);

  // Add note
  const addNote = () => {
    if (!noteText.trim() || !selectedVerse) return;
    setNotes([
      ...notes,
      {
        id: Date.now(),
        book: currentBook,
        chapter: currentChapter,
        verse: selectedVerse.verse || selectedVerse,
        text: noteText.trim(),
        date: new Date().toISOString(),
      },
    ]);
    setNoteText('');
  };

  // Delete note
  const deleteNote = (id) => setNotes(notes.filter(n => n.id !== id));

  // Add bookmark
  const addBookmark = () => {
    if (!selectedVerse) return;
    const exists = bookmarks.some(b => b.book === currentBook && b.chapter === currentChapter && b.verse === (selectedVerse.verse || selectedVerse));
    if (!exists) {
      setBookmarks([
        ...bookmarks,
        {
          id: Date.now(),
          book: currentBook,
          chapter: currentChapter,
          verse: selectedVerse.verse || selectedVerse,
          date: new Date().toISOString(),
        },
      ]);
    }
  };

  // Delete bookmark
  const deleteBookmark = (id) => setBookmarks(bookmarks.filter(b => b.id !== id));

  return (
    <div className="user-content" style={{ padding: 24, background: '#f9fafb', borderRadius: 10, boxShadow: '0 2px 8px #0001', maxWidth: 500, margin: '0 auto' }}>
      <h3 style={{ color: '#2563eb', fontWeight: 700, fontSize: 22, marginBottom: 20 }}>Your Content</h3>
      <div style={{ marginBottom: 32 }}>
        <h4 style={{ color: '#374151', fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Notes</h4>
        <textarea
          value={noteText}
          onChange={e => setNoteText(e.target.value)}
          placeholder={selectedVerse ? `Add note for ${currentBook} ${currentChapter}:${selectedVerse.verse || selectedVerse}` : 'Select a verse to add a note'}
          rows={3}
          style={{ width: '100%', marginBottom: 8, borderRadius: 6, border: '1px solid #d1d5db', padding: 8, fontSize: 15, background: '#fff' }}
        />
        <button onClick={addNote} disabled={!noteText.trim() || !selectedVerse} style={{ marginBottom: 12, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontWeight: 600, cursor: (!noteText.trim() || !selectedVerse) ? 'not-allowed' : 'pointer', opacity: (!noteText.trim() || !selectedVerse) ? 0.6 : 1 }}>
          Add Note
        </button>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {notes.length === 0 && <li style={{ color: '#888' }}>No notes yet.</li>}
          {notes.map(note => (
            <li key={note.id} style={{ borderBottom: '1px solid #eee', marginBottom: 8, paddingBottom: 8, background: '#fff', borderRadius: 6, padding: 10 }}>
              <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>{note.book} {note.chapter}:{note.verse} <span style={{ fontSize: 12, color: '#a3a3a3' }}>({new Date(note.date).toLocaleString()})</span></div>
              <div style={{ marginBottom: 6 }}>{note.text}</div>
              <button onClick={() => deleteNote(note.id)} style={{ fontSize: 12, color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>Delete</button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 style={{ color: '#374151', fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Bookmarks</h4>
        <button onClick={addBookmark} disabled={!selectedVerse} style={{ marginBottom: 12, background: '#10b981', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontWeight: 600, cursor: !selectedVerse ? 'not-allowed' : 'pointer', opacity: !selectedVerse ? 0.6 : 1 }}>
          Bookmark This Verse
        </button>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {bookmarks.length === 0 && <li style={{ color: '#888' }}>No bookmarks yet.</li>}
          {bookmarks.map(bm => (
            <li key={bm.id} style={{ borderBottom: '1px solid #eee', marginBottom: 8, paddingBottom: 8, background: '#fff', borderRadius: 6, padding: 10 }}>
              <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>{bm.book} {bm.chapter}:{bm.verse} <span style={{ fontSize: 12, color: '#a3a3a3' }}>({new Date(bm.date).toLocaleString()})</span></div>
              <button onClick={() => deleteBookmark(bm.id)} style={{ fontSize: 12, color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>Delete</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserContent;
